import type { Project } from '../types'

export const projects: Project[] = [
  {
    id: 'roof',
    titleKey: 'proj.roof.title',
    categoryKey: 'proj.roof.cat',
    locationKey: 'proj.roof.loc',
    descKey: 'proj.roof.desc',
    phases: [
      {
        label: 'before',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/074f5964-5acd-4319-b1d8-0801df3dbd8d.jpg',
        alt: 'Worn asphalt shingle roof with missing and curling shingles before replacement',
      },
      {
        label: 'process',
        src: 'https://i.imgur.com/1pfRy6W.jpeg',
        alt: 'Roofing crew installing new underlayment and stacking architectural shingles',
      },
      {
        label: 'after',
        src: 'https://i.imgur.com/6uT86f3.jpg',
        alt: 'Completed charcoal architectural shingle roof on a two-story brick home',
      },
    ],
  },
  {
    id: 'foundation',
    titleKey: 'proj.foundation.title',
    categoryKey: 'proj.foundation.cat',
    locationKey: 'proj.foundation.loc',
    descKey: 'proj.foundation.desc',
    phases: [
      {
        label: 'before',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/48f75d5a-e8fd-4bb8-8ce1-aa60641ff36f.jpg',
        alt: 'Cracked slab foundation and stair-step brick crack on a settled home',
      },
      {
        label: 'process',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/fb0fa174-b7a1-406b-8f17-62bb55e40010.jpg',
        alt: 'Excavated pit beside a slab with hydraulic jack and concrete pier segments',
      },
      {
        label: 'after',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/604036e9-99fc-4de3-b365-9bafdde96c48.jpg',
        alt: 'Repaired and backfilled foundation edge with repointed brickwork and graded soil',
      },
    ],
  },
  {
    id: 'siding',
    titleKey: 'proj.siding.title',
    categoryKey: 'proj.siding.cat',
    locationKey: 'proj.siding.loc',
    descKey: 'proj.siding.desc',
    phases: [
      {
        label: 'before',
        src: 'https://i.imgur.com/GmnwCmi.jpeg',
        alt: 'House exterior with faded warped wood siding and peeling paint',
      },
      {
        label: 'process',
        src: 'https://imgur.com/A3i5aDQ.jpeg',
        alt: 'Weather barrier exposed while new fiber cement lap siding is installed',
      },
      {
        label: 'after',
        src: 'https://imgur.com/kQOmlD0.jpeg',
        alt: 'Finished house exterior with new blue-gray fiber cement siding and white trim',
      },
    ],
  },
  {
    id: 'gallery',
    titleKey: 'proj.gallery.title',
    categoryKey: 'proj.gallery.cat',
    locationKey: 'proj.gallery.loc',
    descKey: 'proj.gallery.desc',
    phases: [
      {
        label: 'before',
        src: 'https://imgur.com/Efjm1E4.jpeg',
        alt: 'Enclosed patio before gallery room renovation',
      },
      {
        label: 'process',
        src: 'https://imgur.com/T14bEG3.jpeg',
        alt: 'Gallery renovation in progress with new framing and drywall installation',
      },
      {
        label: 'after',
        src: 'https://imgur.com/icHOeVg.jpeg',
        alt: 'Finished gallery room with new ceiling, drywall and complete interior renovation',
      },
    ],
  },
  {
    id: 'bath',
    titleKey: 'proj.bath.title',
    categoryKey: 'proj.bath.cat',
    locationKey: 'proj.bath.loc',
    descKey: 'proj.bath.desc',
    phases: [
      {
        label: 'before',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/a1336ae0-daa9-478b-a348-f11cef0e9ac9.jpg',
        alt: 'Outdated bathroom with beige tile and old vanity before renovation',
      },
      {
        label: 'process',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/8e925466-cabd-4dc6-971d-f92364f53db0.jpg',
        alt: 'Bathroom shower walls waterproofed with backer board during renovation',
      },
      {
        label: 'after',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/01405951-7daf-47fc-85ef-7e72bd985c36.jpg',
        alt: 'Finished bathroom with frameless glass walk-in shower and floating wood vanity',
      },
    ],
  },
]
